import React from 'react';
import moment from 'moment';

export interface IClientsContext {
  sortedInfo?: any;
  filteredInfo?: any;
  setSortedInfo: (sortedInfo: any) => void;
  setFilteredInfo: (filteredInfo: any) => void;
}

export const clientsContextInitialState: IClientsContext = {
  sortedInfo: undefined,
  filteredInfo: undefined,
  setSortedInfo: () => {},
  setFilteredInfo: () => {},
};

export const ClientsContext = React.createContext<IClientsContext>(
  clientsContextInitialState,
);

export const useClientsContext = (): IClientsContext => {
  const [sortedInfo, _setSortedInfo] = React.useState(
    clientsContextInitialState.sortedInfo,
  );
  const [filteredInfo, _setFilteredInfo] = React.useState(
    clientsContextInitialState.filteredInfo,
  );

  const setSortedInfo = React.useCallback((sortedInfo: any): void => {
    _setSortedInfo(sortedInfo);
  }, []);
  const setFilteredInfo = React.useCallback((filteredInfo): void => {
    _setFilteredInfo(filteredInfo);
  }, []);

  return {
    sortedInfo,
    filteredInfo,
    setSortedInfo,
    setFilteredInfo,
  };
};
